module.exports = __webpack_public_path__ + "img/tips5.9f181aa3.png";